/* eslint-disable no-undef */
import React, { Component } from "react";
import { connect } from "react-redux";
import ReactPixel from "react-facebook-pixel";
import {
  clearNewMemberDone,
  selectMemberInfo,
} from "../../../state/ducks/member";
import { beginAuthenticate } from "../../../state/ducks/login/index";

function changebg() {

    var num = Math.ceil(Math.random() * 2);
    document.body.background = "assets/img/loginBackground/loginback_" + num + ".jpg";
    document.body.style.backgroundSize = "cover";

}

class NewMemberDone extends Component {
  state = {
    loginType: 1,
    platform: "web",
    token: "",
  };

  beginAuthenticate = () => {

    const { member } = this.props;
    const postData = {
      username: member.newMember.telefonNo,
      password: member.newMember.kod,
      loginType: this.state.loginType,
      platform: this.state.platform,
      token: this.state.token,
      authType: 2,
    };
    this.props.beginAuthenticate(postData);
    this.setState({
      userName: "",
      password: "",
    });

    this.createCaptchaToken();
  };

  componentDidMount() {
    changebg();
    ReactPixel.init("210664537388285");
    ReactPixel.pageView();
    this.createCaptchaToken();
    if (this.props.member?.doneMember) {
      var that = this;
      setTimeout(function () {
        that.props.clearRedirect();
        that.beginAuthenticate();
      }, 3000);
    }
  }

  createCaptchaToken() {
    var that = this;
    grecaptcha.ready(function () {
      grecaptcha
        .execute("6LeiYdwUAAAAAFsmN76CLhs9VADdnPT4OnzKWCFT", {
          action: "/Home",
        })
        .then((token) => {
          that.setState({ token: token });
        });
    });
  }

  render() {
    return (
      <div className="container-fluid">
        <div className="row d-flex align-items-center justify-content-center vh-100">
          <div
            className="col-10 col-md-7 col-lg-6 col-xl-4 t-sifreAlani"
            style={{ height: 430 }}
          >
            <div className="row no-gutters d-flex justify-content-center px-4 w-100 pt-0 ">
              {/* LOGO */}
              <div className="col-12 d-flex justify-content-center">
                {/*<i class="t-icon-checkmark t-loginSifreAlBaslikIcon"></i>*/}
                <img src="/assets/img/gif/loading.gif" />
              </div>
              <div className="col-12 pt-0 pb-3 t-loadingMesaj">
                Teşekkürler.
                <br />
                İşleminiz Başarılı.
                <br />
                İ-Şubeye Giriş Yapıyorsunuz.
                <br />
              </div>
            </div>
          </div>
        </div>
      </div>

    );
  }
}

const mapStateToProps = (state) => {
  return {
    member: selectMemberInfo(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  clearRedirect: () => dispatch(clearNewMemberDone()),
  beginAuthenticate: (postData) => dispatch(beginAuthenticate(postData)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NewMemberDone);
